export const accountSelector = (state) => ({
  account: state.account.accountV1
});

export const accountSelectorV2 = (state) => ({
  account: state.account.accountV2
});
